<template>
    <div class="position-relative">
        <div v-if="row.selected" class="position-absolute bg-primary text-white px-3 pointer row-tab move" @click="onRowTabSelected">
            Row <i class="fas fa-ellipsis-v fa-xs"></i>
        </div>
        <div @mouseover="isMouseOver = true" @mouseout="isMouseOver = false" class="d-flex w-100 p-2"
             :class="dynamicClasses" @click.stop="onRowClick"
             :style="rowStyle">

            <!-- Not loving this if/else here -->
            <div v-if="row.includeContainer" class="d-flex container">

                    <column-container v-for="(column, columnIndex) in row.columns"
                                      class="h-100"
                                      :row="row"
                                      :column="column"
                                      :index="index"
                                      :key="index + columnIndex + 'Column'"
                                      :layout="layout"
                                      :page="page"
                                      :view="view"></column-container>

            </div>


            <column-container v-else v-for="(column, columnIndex) in row.columns"
                              :row="row"
                              :column="column"
                              :index="index"
                              :key="index + columnIndex + 'Column'"
                              :layout="layout"
                              :page="page"
                              :view="view"></column-container>

        </div>
    </div>
</template>

<script>
    import ColumnContainer from "./ColumnContainer.vue";
    import UIUtil from "../../utils/UIUtil";
    import PageFactory from "../../utils/PageFactory";

    export default {
        name: 'RowContainer',
        components: {ColumnContainer},
        props: ['layout', 'row', 'index', 'document', 'view', 'page'],
        data() {
            return {
                model: webase.model,
                isMouseOver: false,
                uiUtil: new UIUtil(),
                pageFactory: new PageFactory(),
                angle: '50',
                color1: '#8930fd',
                color2: '#49ccf9',
                imageOverlay: false
            }
        },
        computed: {
            linearGradient() {
                this.color1 = this.row.background.color
                this.color2 = this.row.background.secondaryColor
                return `linear-gradient(to right, ${this.color1}, ${this.color2})`;
            },
            radialGradient() {
                this.color1 = this.row.background.color
                this.color2 = this.row.background.secondaryColor
                return `radial-gradient(circle at center, ${this.color1}, ${this.color2})`;
            },
            rowStyle() {
                this.imageOverlay = this.row.background.imageOverlay

                if( this.hasBgImage && this.imageOverlay) {
                    this.color1 = this.row.background.color

                    return {
                        color: this.row.color ? this.row.color : '#000000',
                        backgroundSize: 'cover',
                        backgroundImage: `linear-gradient(${this.color1}90, ${this.color1}90), url('${this.row.background.image.url}')`,
                        minHeight: this.row.minHeight ? this.row.minHeight + 'px' : 'inherit'
                    }
                }

                if( this.hasBgImage) {
                    return {
                        color: this.row.color ? this.row.color : '#000000',
                        backgroundSize: 'cover',
                        backgroundImage: `url('${this.row.background.image.url}')`,
                        minHeight: this.row.minHeight ? this.row.minHeight + 'px' : 'inherit'
                    }
                }

                if( this.hasBgPattern ) {
                    return {
                        minHeight: this.row.minHeight ? this.row.minHeight + 'px' : 'inherit',
                        ...this.bgPatternStyle
                    }
                }

                // don't add color and background styles if we have a theme
                if(this.layout.theme_id) {
                    return {
                        minHeight: this.row.minHeight ? this.row.minHeight + 'px' : 'inherit'
                    }
                }

                let styleObject = {
                    ...this.colorStyle,
                    ...this.baseStyle,
                }

                return styleObject
            },
            baseStyle() {
                return {
                    color: this.row.color ? this.row.color : '#000000',
                    minHeight: this.row.minHeight ? this.row.minHeight + 'px' : 'inherit'
                }
            },
            colorStyle() {
                if(this.row.background.gradient === 'linear gradient') {
                    return {
                        backgroundImage: this.linearGradient
                    }
                }

                if(this.row.background.gradient === 'radial gradient') {
                    return {
                        backgroundImage: this.radialGradient
                    }
                }

                if(this.row.background.type === 'none') {
                    return {}
                }

                return {
                    backgroundColor: this.row.background && this.row.background.color ? this.row.background.color : '#FFFFFF'
                }
            },
            bgImageStyle() {
                if( !this.hasBgImage ) {
                    return ''
                }

                this.imageOverlay = this.row.background.imageOverlay

                if( this.imageOverlay ) {
                    this.color1 = this.row.background.color
                    let styleString = 'linear-gradient(to right, ' + this.color1 + '80, ' + this.color1 + '80), '
                    styleString += `url('${this.row.background.image.url}');`

                    console.log('styleString')
                    console.log(styleString)
                    return {
                        'backgroundImage': styleString
                    }
                }
                
                return {
                    'background-image': `url(${this.row.background.image.url})`
                }
            },
            bgPatternClass() {
                let background = this.row.background
                return 'pattern-' + background.pattern + '-' + background.patternSize + ' text-' + background.color + ' bg-' + background.secondaryColor
            },
            bgPatternStyle() {
                return {
                    color: this.row.background.color ? this.row.background.color : '',
                    backgroundColor: this.row.background.secondaryColor ? this.row.background.secondaryColor : ''
                }
            },
            dynamicClasses() {
                let classes = this.isMouseOver || this.row.selected ? 'drag-border pointer' : ''
                let baseClasses = classes + ' ' + this.marginClass + ' ' + this.paddingClass

                if(this.hasBgImage) {
                    baseClasses += ' row-image-background'
                }
                else if(this.hasBgPattern) {
                    baseClasses += (' ' + this.bgPatternClass)
                }

                if(this.index > -1) {
                    baseClasses += (this.index % 2 === 0 ? ' primary-background' : ' secondary-background')
                }

                return baseClasses
            },
            marginClass() {
                if(!this.row.margin) {
                    return ''
                }

                return webase.utils.ui.getMarginClass(this.row.margin)
            },
            paddingClass() {
                if(!this.row.padding) {
                    return ''
                }

                return webase.utils.ui.getPaddingClass(this.row.padding)
            },
            hasBgImage() {
                let background = this.row.background
                return background && background.type === 'image' && background.image ? true : false
            },
            hasBgPattern() {
                let background = this.row.background
                return background && background.type === 'pattern' && background.pattern && background.patternSize ? true : false
            }
        },
        mounted() {
            if (!this.row.margin) {
                this.row.margin = {
                    side: 'none',
                    value: '0'
                }
            }

            if(this.row.background.imageOverlay === undefined) {
                this.row.background.imageOverlay = false
            }

            if (!this.row.padding) {
                this.row.padding = {
                    side: 'none',
                    value: '0'
                }
            }

            if (!this.row.minHeight) {
                this.row.minHeight = ''
            }

            if (!this.row.background) {
                this.row.background = this.pageFactory.defaultBackground()
            }

        },
        methods: {
            onRowClick(event) {
                webase.utils.layout.deslectRows(this.layout)
                this.row.selected = true
                this.layout.selectedRow = this.row
                bootstrap.Dropdown.clearMenus(event) // HACK to hide dropdowns
                //$('#componentContextMenu').dropdown('dispose')
            },
            onRowTabSelected(event) {
                event.stopPropagation()
                webase.utils.layout.deselectColumns(this.layout)
                this.layout.selectedColumn = null
                this.row.selected = true
                this.layout.selectedRow = this.row
            },
            initColumn(column) {
                column = Object.assign(this.pageFactory, column)
            }
        }
    }
</script>
